import React, { FC, useContext, useEffect, useMemo, useState } from 'react';
import { InfoContext } from '../../../shared/contexts';
import { Tab, Tabs } from '@hdi-seguros/web-components.tabs';
import { PageHeader } from '../../../shared/components/MainLayout/components';
import { ColSize, RowSize } from '../../../shared/components';
import { ENDORSEMENTS_TABS_KEY_VALUES } from './shared/enums/endorsements-tabs-values-enum';
import { ENDORSEMENTS_TYPES_VALUES } from './shared/enums/endorsements-types-values-enum';
import { EndorsementsTab } from './components/EndorsementsTabs';
import { EndorsementsModal } from './shared/components/EndorsementsInitialTextModal';
import { ConfirmationEndorsements } from './shared/components/confirmationEndorsements';

interface EndorsementsPageProps {
    title: string;
}


export const EndorsementsPage: FC<EndorsementsPageProps>  = ({title}) => {
    const { setTitle } = useContext(InfoContext);
    const [activeTab, setActiveTab] = useState(ENDORSEMENTS_TABS_KEY_VALUES.ENDORSEMENTS_ELEVATORS_BOILERS.toString());
    const [showInitialModal, setShowInitialModal] = useState(true);
    const [showEndorsementConfirmation, setShowEndorsementConfirmation] = useState(false);

    const [endorsementsMessage, setEndorsementsMessage] = useState<string>("");

    const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

    const handleEndorsementsProcessed = (message: string) => {
        setEndorsementsMessage(message);
        setShowEndorsementConfirmation(true)
    };
    
    useEffect(() => {
        setTitle(title);
    }, []);

    const TABS: Array<Tab> = useMemo(() => [
        {
            label: 'Endoso de Aumento de Suma de Ascensores y Calderas',
            children: <EndorsementsTab  onEndorsementsProcessed={handleEndorsementsProcessed} type={ENDORSEMENTS_TYPES_VALUES.CALDERAS} />,
            key: ENDORSEMENTS_TABS_KEY_VALUES.ENDORSEMENTS_ELEVATORS_BOILERS,
            closable: false,
        },
        {
            label: 'Endoso de Aumento de Vehículos',
            children: <EndorsementsTab onEndorsementsProcessed={handleEndorsementsProcessed} type={ENDORSEMENTS_TYPES_VALUES.AUTOS} />,
            key: ENDORSEMENTS_TABS_KEY_VALUES.ENDORSEMENTS_CARS,
            closable: false,
        }
    ], [handleEndorsementsProcessed]);

    const onConfirmEndorsementFinalMessage = () => {        
        setShowEndorsementConfirmation(false)
    }

    return (
        <>
            <PageHeader actions={undefined} />

            {showEndorsementConfirmation ? (
                <ConfirmationEndorsements onconfirm={ onConfirmEndorsementFinalMessage } description={endorsementsMessage} />
            ) : (
                <RowSize>
                    <ColSize size={100}>
                        <Tabs 
                            onChange={setActiveTab}
                            handlePressTab={handlePressTab}
                            activeKey={activeTab}
                            items={TABS}
                        />
                    </ColSize>
                </RowSize>
            )}

            {showInitialModal && (
                <EndorsementsModal open={showInitialModal} onClose={() => setShowInitialModal(false)} />
            )}
        </>

    )
};

